@use '@fukuri-admins/ui/layout' as *;

.statusCol     { width: 110px; }
.publishedAtCol { width: 160px; }
.viewRateCol   { width: 100px; }
.actionCol     { width: 88px; }

.titleCell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.deleteItem {
  color: text('Red');
}
